<!-- https://vuetifyjs.com/en/api/v-data-table/#api-props  -->
<!-- This is a data table with dynamically generated headers using props to change url -->
<template>
    <v-row justify-md="center" wrap>
        <v-row></v-row>
        <MaterialfyColorCard :cardShowInnerText="false" :cardShowDivider="true" :cardShowActions="false"
            cardColor="secondary">
            <template v-slot:crdInner>
                <MaterialfyBasicCard cardMaxWidth="1000" cardTitle="API" :cardShowSubHeader="false"
                    :cardShowAvatar="false">
                    <template v-slot:crdInner>
                        <validation-observer ref="observer" v-slot="{ invalid }">
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-container>
                                    <v-row wrap>
                                        <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0">
                                        </v-col>
                                        <v-col cols="10" xs="12" sm="12" md="10" class="flex-grow-0 flex-shrink-0">
                                            <validation-provider v-slot="{ errors }" name="Exchange" rules="required">
                                                <v-select v-model="exchange" :items="itemsExchange" item-text="exchange"
                                                    item-value="id" label="Select Exchange" persistent-hint
                                                    return-object single-line @change="onChange($event)"
                                                    :disabled="isUpdate"></v-select>
                                                <div class="invalid-feedback">
                                                    <p style="color:red">{{ errors[0] }}</p>
                                                </div>
                                            </validation-provider>
                                        </v-col>
                                        <v-col xs1></v-col>
                                    </v-row>
                                    <v-row wrap>
                                        <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0">
                                        </v-col>
                                        <v-col cols="10" xs="12" sm="12" md="10" class="flex-grow-0 flex-shrink-0">
                                            <validation-provider v-slot="{ errors }" name="Api Key"
                                                rules="required|max:64">
                                                <v-text-field v-model="apikey" :counter="64" :error-messages="errors"
                                                    label="Api Key" required></v-text-field>
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <v-row wrap>
                                        <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0">
                                        </v-col>
                                        <v-col cols="10" xs="12" sm="12" md="10" class="flex-grow-0 flex-shrink-0">
                                            <validation-provider v-slot="{ errors }" name="Secret"
                                                rules="required|max:64">
                                                <v-text-field v-model="secret" :counter="64" :error-messages="errors"
                                                    label="Secret" required></v-text-field>
                                            </validation-provider>
                                        </v-col>
                                    </v-row>
                                    <div v-if="isPassphrase">
                                        <v-row wrap>
                                            <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0">
                                            </v-col>
                                            <v-col cols="10" xs="12" sm="12" md="10" class="flex-grow-0 flex-shrink-0">
                                                <validation-provider v-slot="{ errors }" name="Passphrase"
                                                    rules="required|max:64">
                                                    <v-text-field v-model="passphrase" :counter="64"
                                                        :error-messages="errors" label="Passphrase"
                                                        required></v-text-field>
                                                </validation-provider>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-if="!isPassphrase">
                                    </div>
                                    <v-btn :loading="loading" :disabled="invalid" color="success"
                                        @click="saveClient">Guardar</v-btn>
                                </v-container>
                            </v-form>
                        </validation-observer>
                    </template>

                </MaterialfyBasicCard>
            </template>

        </MaterialfyColorCard>
        <v-row>
            <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
                :float-right="right">
                <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                <div>
                    {{ msg_toast }}
                </div>
                <v-icon size="16" @click="closeAlert">
                    mdi-close-circle
                </v-icon>
            </v-snackbar>
        </v-row>
    </v-row>
</template>

<script>
import UserService from '@/services/user.service'
import Client from '@/models/client'
import { required, email, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
// import { genericApi } from "../../plugins/axios"

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} no puede estar vacio.',
})

extend('max', {
    ...max,
    message: '{_field_} no puede ser mayor de {length} caracteres,',
})

extend('email', {
    ...email,
    message: 'Email debe ser valido.',
})

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        // DialogMessages
        // Asistente
    },
    props: {
        showHeader: {
            default: true
        },
        activateBreakpoint: {
            default: 0
        }
    },
    data: () => ({
        title: 'API',
        client: new Client('', '', ''),
        idClient: '',
        isPass: false,
        // Models
        valid: '',
        exchange: '',
        itemsExchange: [],
        apikey: '',
        secret: '',
        passphrase: '',
        // Shows
        isSelected: false,
        successful: false,
        // Tutorial
        titleTutorial: '',
        textTutorial: '',
        urlTutorial: '',
        pic_01: '',
        pic_02: '',
        // 18012025 Se añade nueva mejora LOADING INICIO
        loader: null,
        loading: false,
        // 18012025 Se añade nueva mejora LOADING FIN
        isUpdate: false,
        // SanckBar
        color: null,
        colors: ["purple", "info", "success", "warning", "error"],
        top: true,
        bottom: false,
        left: false,
        right: false,
        dialogElegirBot: false,
        snackbar: false,
        msg_title: '',
        msg_toast: '',
    }),

    computed: {
        isPassphrase() {
            if (this.isPass) {
                return true
            } else {
                return false
            }
        },
    },
    // called when page is created before dom to load data from api
    created() { },
    mounted() {
        if (this.$route.params.idApi !== null) {
            this.idClient = this.$route.params.idApi
        }
        UserService.getExchanges().then(
            response => {
                // console.log(response.data)
                this.itemsExchange = response.data
            },
            error => {
                this.content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );
        if (this.idClient !== '' && this.idClient !== undefined) {
            this.isUpdate = true
            UserService.getClient(this.idClient).then(
                response => {
                    // console.log(response.data)
                    this.content = response.data
                    this.client.id = this.idClient
                    this.apikey = this.content.apiKey
                    this.secret = this.content.secret
                    this.passphrase = this.content.passphrase
                    this.exchange = this.content.exchange
                    this.isPass = this.content.exchange.passphrase
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        }
    },
    methods: {
        saveClient() {
            // 18012025 Se añade nueva mejora LOADING INICIO
            this.loader = 'loading'
            this.loading = true
            // 18012025 Se añade nueva mejora LOADING FIN
            this.client.apiKey = this.apikey;
            this.client.secret = this.secret;
            this.client.passphrase = this.passphrase;
            this.client.exchange = this.exchange;
            UserService.postClient(this.client).then(
                response => {
                    this.successful = true
                    setTimeout(() => (this.responseSave('success', response)), 2000)
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.successful = false
                    setTimeout(() => (this.responseSave('error', error.response.data)), 2000)
                }
            );
        },
        onChange(exchange) {
            // console.log(exchange.passphrase)
            this.isSelected = true
            this.isPass = exchange.passphrase
            this.titleTutorial = 'Tutorial ' + exchange.exchange
            this.textTutorial = 'Accede a la siguiente web para crear la API.'
            if (exchange.exchange === 'KUCOIN') {
                this.urlTutorial = 'https://www.kucoin.com/es/support/360015102174#:~:text=Ve%20a%20KuCoin.com%20e,y%20las%20restricciones%20de%20IP.'
            } else {
                this.urlTutorial = 'https://www.binance.com/es/support/faq/c%C3%B3mo-crear-claves-api-en-binance-360002502072'
            }
        },
        goToAPI() {
            window.open(this.urlTutorial, '_blank');
        },
        responseSave(response, msg) {
            // console.log(response)
            this.top = true;
            this.bottom = false;
            this.left = false;
            this.right = false;
            this.msg_toast = msg
            this.snackbar = true;

            if (response === 'success') {
                this.color = 'success'
                this.successful = true
            } else {
                this.color = 'error'
                this.successful = false
            }
            // // 18012025 Se añade nueva mejora LOADING INICIO
            // this.loading = false
            // // 18012025 Se añade nueva mejora LOADING FIN
            // this.$refs.dialog.openModal()
            // this.$refs.dialog.component = 'API'
            // this.$refs.dialog.tituloDialog = 'GUARDAR API'
            // this.$refs.dialog.msgError = msg
            // this.$refs.dialog.isShow = true
            // if (response === 'success') {
            //     this.$refs.dialog.types = 'success'
            // } else {
            //     this.$refs.dialog.types = 'error'
            // }
        },
        closeAlert() {
            // console.log(value)
            if (this.successful) {
                this.snackbar = false
                this.loading = false
                this.$router.push('/user-apis')
            }
        }
    },
};
</script>

<style>
table.v-table thead tr {
    color: red !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
